import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Alert, Spin } from 'antd';
import { nativeRequest } from './transport';
import TandemSessionBoundary from '../../features/tandem/TandemSessionBoundary';
import { TandemStatus } from '../../features/tandem/api';
import { beginJoin, bootstrapMetadata, failedJoin } from 'services/monitoring';

const NativeSession = React.lazy(() => import('./Entry'));
/** Resolve engine before mounting legacy containers, stores, timers or sockets. */
export default function SessionEngineRoute({ legacy }: { legacy: React.ReactNode }) {
  const { id } = useParams<{ id: string }>();
  const [result, setResult] = useState<{ id: string; engine?: string; whichMarkets?: number; error?: string; tandem?: TandemStatus | null } | null>(null);
  useEffect(() => {
    beginJoin(Number(id));
    const joinId = bootstrapMetadata(Number(id))?.join_id;
    const controller = new AbortController();
    setResult(null);
    void nativeRequest<{ execution_engine: string; which_markets?: number; tandem?: TandemStatus }>(`/sessions/${id}/execution-context/`, undefined, controller.signal)
      .then(data => { if (!controller.signal.aborted) setResult({ id, engine: data?.execution_engine, whichMarkets: data?.which_markets, tandem: data?.tandem }); })
      .catch(reason => { if (!controller.signal.aborted) {
        failedJoin(Number(id), joinId);
        setResult({ id, error: String(reason) });
      } });
    return () => controller.abort();
  }, [id]);
  if (!result || result.id !== id) return <Spin />;
  if (result.error) return <Alert type="error" message={result.error} />;
  if (!['legacy', 'fast'].includes(result.engine || '')) return <Alert type="error" message="Unknown execution engine" />;
  const content = result.engine === 'legacy' ? legacy : <React.Suspense fallback={<Spin />}><NativeSession key={id} sessionId={Number(id)} whichMarkets={result.whichMarkets} /></React.Suspense>;
  return result.tandem ? <TandemSessionBoundary key={id} sessionId={Number(id)} initial={result.tandem}>{content}</TandemSessionBoundary> : <>{content}</>;
}
